import { render } from "./DeliveryAreasCreate.vue?vue&type=template&id=525fc63f"
import script from "./DeliveryAreasCreate.vue?vue&type=script&lang=js"
export * from "./DeliveryAreasCreate.vue?vue&type=script&lang=js"

import "./DeliveryAreasCreate.vue?vue&type=style&index=0&id=525fc63f&lang=css"

import exportComponent from "/Users/borchekostovski/Documents/Projects/CreativeLabs/Projects/Ching-a-ling/ching-a-ling-cms-menu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__